import React from 'react';
import Helmet from 'react-helmet';
import { Link } from 'gatsby';
import PageLayout from '../components/PageLayout';
import styles from './speaker.module.scss';
import fbIcon from '../assets/images/fb-icon.png';
import twitterIcon from '../assets/images/twitter-icon.png';
import GoChevronLeft from 'react-icons/lib/go/chevron-left';

const SpeakerTemplate = (props) => {
  const { frontmatter: { title, country, shareImage, profileImage }, html } = props.data.markdownRemark;
  const shareURL = "https://www.marxismconference.org" + props.location.pathname;
  return (
    <PageLayout location={props.location}>
      <Helmet>
        <title>{title}</title>
        <meta property="og:title" content={title + ' at Marxism 2020'} />
        {html ? <meta property="og:description" content={html.replace(/<\/?[^>]+(>|$)/g, "")} /> : ''}
        {shareImage ? <meta property="og:image" content={shareImage} /> : ''}
        {shareImage ? <meta property='twitter:image:src' content={shareImage} /> : ''}
        <meta property='twitter:title' content={title} />
      </Helmet>
      <div className={styles.content}>
          <img src={profileImage} className={styles.profileImage} alt="" />
          <h1 className={styles.name}> {title} </h1>
          <div>{country}</div>
        <div className={styles.shareSpeaker}>
          SHARE THIS SPEAKER:
          <a href={"http://www.facebook.com/sharer/sharer.php?u=" + shareURL} target="_blank" rel="noopener noreferrer">
            <div className={styles.icon}>
              <img src={fbIcon} className={styles.fbIcon} alt="Facebook" />
            </div>
          </a>
          <a href={"https://twitter.com/share?text=" + title + " is speaking at Marxism 2020&url=" + shareURL} target="_blank" rel="noopener noreferrer">
            <div className={styles.icon}>
            <img src={twitterIcon} className={styles.twitterIcon} alt="Twitter" />
            </div>
          </a>
        </div>
          <div className={styles.bio} dangerouslySetInnerHTML={{__html: html}} />
        <Link className={styles.backButton} to='/speakers/'><GoChevronLeft /> View All Speakers</Link>
      </div>
    </PageLayout>
  );
}

export default SpeakerTemplate;

export const pageQuery = graphql`
  query GetSpeaker($path: String!) {
    markdownRemark(fields: { path: { eq: $path } }) {
      html,
      frontmatter {
        title,
        country,
        shareImage,
        profileImage,
      }
    }
  }
`;
